<template>
  <div class="member-label-container">
    <div v-for="item in data" :key="item.type" class="member-label-column">
      <div class="member-type f-rte" :class="item.type">
        <strong>
          {{ item.type.charAt(0).toUpperCase() + item.type.slice(1) }}
          countries
        </strong>
      </div>
      <div class="column-wrapper">
        <ul v-for="(column, i) in item.cols" :key="`${item.type}-${i}`">
          <li
            v-for="country in column.data"
            :key="country.ISO3"
            :class="[
              `member-${country.year}-${country.idx}`,
              { '--previous-member': year !== country.year },
            ]"
          >
            {{ country.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numCols: null,
    };
  },
  props: {
    data: {
      required: true,
    },
    year: {
      required: true,
    },
  },
};
</script>

<style>
.member-label-container {
  display: flex;
  padding-top: 32px;
  opacity: 0;
  padding-right: 35px;
}
.column-wrapper {
  display: flex;
}
.member-label-column {
  text-align: right;
}
.member-label-column:not(:first-child) {
  margin-left: 32px;
}
.member-label-column li {
  text-decoration: none;
  margin-bottom: 0 !important;
  opacity: 0;
  color: #04f;
  transform: translateY(200%);
  font-size: 1rem;
  line-height: 1.5rem;
}
.member-label-column li:before {
  content: none !important;
}
.--previous-member {
  color: #e3e3e3 !important;
}
.member-type {
  margin-bottom: 10px;
  transform: translateY(-100%);
  opacity: 0;
  color: #bababa;
}

@media screen and (min-width: 1480px) {
  .member-label-column ul {
    width: calc(1384px / 6);
  }
}
@media screen and (min-width: 1280px) and (max-width: 1479px) {
  .member-label-column ul {
    width: calc(((100vw - 96px) / 5));
  }
}
@media screen and (min-width: 960px) and (max-width: 1279px) {
  .member-label-column ul {
    width: calc(((100vw - 96px) * 2 / 9));
  }
  .member-label-column:not(:first-child) {
    margin-left: 0;
  }
}
@media screen and (max-width: 959px) {
  .member-label-container {
    display: none;
    visibility: hidden;
  }
}
</style>
